module.exports = "/static/assets/8beb9da10f72d02b48baf0b24ac72449.svg";